// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__Nv5Z8","checkboxCol":"Table_checkboxCol__1SJfn","emailCol":"Table_emailCol__3Ft7N","actionCol":"Table_actionCol__Gkh-A"};